import classNames from 'classnames'
import MergeHelpImage from '../../../../../assets/images/ringcentral-help-merge.png'
import RecordingHelpImage from '../../../../../assets/images/ringcentral-help-recording.png'
import styles from './RingCentralHowItWorks.module.scss'

export const RingCentralHowItWorks = () => {
  return (
    <div>
      <div>
        <h5>1. Connect your RingCentral account.</h5>
        <div className='mt-2'>Zocks redirects you to Ring Central where you can authorize the access request to set up the connection.</div>
      </div>
      <div className='mt-3'>
        <h5>2. Zocks matches calls to meetings automatically</h5>
        <ul className='mt-2'>
          <li>For scheduled upcoming meetings, set the meeting platform to &ldquo;RingCentral&rdquo;.</li>
          <li>Zocks links calls to scheduled meetings by phone number, or creates new meetings for unexpected calls.</li>
        </ul>
      </div>
      <div className='mt-3'>
        <h5>3. Set your processing method</h5>
        <div className='mt-3 d-flex gap-4 align-items-start'>
          <div className='flex-fill overflow-hidden'>
            <img className='w-100 d-block' alt='Merge Zocks into your calls' src={MergeHelpImage} />
            <div className='mt-2'>
              <div className='fw-bold mb-1'>Merge Zocks into your calls</div>
              <div>
                When you start a call, Zocks calls you separately. Use RingCentral&apos;s merge feature to combine both calls to add your AI Assistant to the
                conversation. You can manually add or remove the assistant during any live call.
              </div>
            </div>
          </div>
          <div className='fw-bold fs-5 flex-shrink-0 align-self-center'>OR</div>
          <div className='flex-fill overflow-hidden'>
            <div className='d-flex gap-3 align-items-start'>
              <img className={classNames('d-block flex-shrink-0', styles.recordingImage)} alt='Process recordings' src={RecordingHelpImage} />
              <div>
                <div className='fw-bold mb-1'>Process recordings</div>
                <div>
                  You can manually record phone calls, and let Zocks process the recording when the meeting ends. Optionally you can turn on on-demand or
                  automatic call recording in the RingCentral Admin Portal, to start recording at the beginning of each call.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
